import { ColDef } from 'ag-grid-community';
import ItemTable from '../ItemTable';
import PriceCell from '../MenuItemTable/cells/PriceCell';
import { useModifiersContext } from '../../contexts/ModifiersContext';
import DescriptionCell from '../MenuItemTable/cells/DescriptionCell';
import ModifierNameCell from '../MenuItemTable/cells/ModifierNameCell';
import DateTimeCell from '../MenuItemTable/cells/DateTimeCell';
import MobileItemTable from '../MobileItemTable';

interface ModifiersTableProps {
  isDesktop?: boolean;
}

const ModifiersTable = ({ isDesktop }: ModifiersTableProps) => {
  const { modifiers } = useModifiersContext();

  const nameCellGetter = (params: any) => ({
    imageURL: params.data.imageURL,
    name: params.data.name,
    modifierID: params.data.modifierID,
    price: params.data.price?.toString() || '',
    description: params.data.description || '',
    isHidden: params.data.isHidden
  });

  const nameComparator = (values1: any, values2: any) => {
    if (values1 === values2) return 0;
    return values1 > values2 ? 1 : -1;
  };

  const descriptionCellGetter = (params: any) => ({
    description: params.data.description || '',
    isHidden: params.data.isHidden
  });

  // Only shows a value when the row is actually hidden -- a dangling reappearAt on an already-visible
  // row (e.g. Otter unhid it independently of a pending schedule) should never display.
  const reappearAtCellGetter = (params: any) => ({
    timestamp: params.data.isHidden ? params.data?.reappearAt : null,
    isHidden: false
  });

  const minWidth = isDesktop ? 80 : 270;

  const COLUMNS: ColDef[] = isDesktop
    ? [
        {
          headerName: 'NAME',
          valueGetter: nameCellGetter,
          headerClass: 'name-header',
          cellRenderer: ModifierNameCell,
          minWidth,
          sortable: true,
          comparator: nameComparator,
          wrapText: true,
          autoHeight: true,
          suppressMovable: true
        },

        {
          headerName: 'REAPPEARS',
          valueGetter: reappearAtCellGetter,
          headerClass: 'custom-header',
          cellRenderer: DateTimeCell,
          minWidth: 120,
          suppressMovable: true
        },
        {
          headerName: 'DESCRIPTION',
          valueGetter: descriptionCellGetter,
          headerClass: 'custom-header',
          cellRenderer: DescriptionCell,
          minWidth: 200,
          suppressMovable: true,
          wrapText: true,
          autoHeight: true
        },
        {
          headerName: 'PRICE',
          field: 'price',
          headerClass: 'custom-header',
          cellRenderer: PriceCell,
          minWidth: 80,
          suppressMovable: true
        }
      ]
    : [
        {
          headerName: 'NAME',
          valueGetter: nameCellGetter,
          headerClass: 'name-header',
          cellRenderer: ModifierNameCell,
          minWidth,
          sortable: true,
          comparator: nameComparator,
          wrapText: true,
          autoHeight: true,
          suppressMovable: true
        },
        {
          headerName: 'PRICE',
          field: 'price',
          headerClass: 'custom-header',
          cellRenderer: PriceCell,
          minWidth: 80,
          suppressMovable: true
        }
      ];

  return isDesktop ? (
    <ItemTable className="modifiers-table-container" items={modifiers} columns={COLUMNS} draggable={false} />
  ) : (
    <MobileItemTable
      className="mobile-modifiers-table-container"
      items={modifiers}
      columns={COLUMNS}
      draggable={false}
      rowHeight={75}
    />
  );
};

export default ModifiersTable;
